import { render, staticRenderFns } from "./VoiceList.vue?vue&type=template&id=0db4b305&scoped=true&"
import script from "./VoiceList.vue?vue&type=script&lang=js&"
export * from "./VoiceList.vue?vue&type=script&lang=js&"
import style0 from "./VoiceList.vue?vue&type=style&index=0&id=0db4b305&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db4b305",
  null
  
)

export default component.exports